import {decodeMimePartContent, MimeParser} from "../../parsers/MimeParser";
import {ContentType} from "../../util/ContentTypes";
import {DateTime} from "luxon";
import {FullEmailContent} from "../../domain/EmailContentDto";
import {ticksFromDateTime} from "../../util/DateHelper";
import {EmailThreadView} from "./EmailThreadView";
import React, {useMemo} from "react";

interface RawEmailViewProps {
    content: string;
    embeddedView: boolean;
}

export const RawEmailView = ({content, embeddedView}: RawEmailViewProps) => {
    return useMemo(() => {
            const parser = new MimeParser(content, true);
            parser.parse();
            const bestPart = parser.findBestPart(ContentType.HtmlText);
            const html = decodeMimePartContent(bestPart);

            const normalisedDateString = (parser.date ?? "").replaceAll(/[:/,]/g, "").replace("Sept", "Sep");
            let fixedDateString = normalisedDateString.replace("(UTC)", "").trim();

            const date = DateTime.fromFormat(fixedDateString, "ccc d MMM yyyy HHmmss ZZZ").toLocal();

            // console.log("Date", parser.date, date, date.toString(), getBrowserTimezone().name);
            const attachments = parser.getAttachmentParts();
            const email: FullEmailContent = {
                Id: 0,
                Subject: parser.subject ?? "",
                Content: html,
                ContentType: content,
                IsHtmlContent: bestPart.contentType === ContentType.HtmlText,
                Date: ticksFromDateTime(date),
                From: parser.headers.get("from"),
                To: parser.headers.get("to"),
                CC: parser.headers.get("cc"),
                Importance: parser.headers.get("importance"),
                AttachmentCount: attachments.length,
                DecryptedAttachments: attachments,
                Category: null,
                IsVerifiedSender: true,
                Read: 1,
                IsDraft: true,
            } as FullEmailContent;

            return <EmailThreadView itemContent={{Id: 0, Emails: [email]}} embeddedView={embeddedView}/>;
        }
        , [content, embeddedView]);
};
